module.exports = __webpack_public_path__ + "img/maxine.a5cbdefa.png";